export enum BydFeatureFlagsEnum {
  KEY = 'featureFlags',
}
